import { useMutation } from "@tanstack/react-query";

import { pauseAll } from "../api/ventura/contract";
import { useConfig } from "./useConfig";

function usePauseAllContracts(contractId) {
  const {
    apiHost
  } = useConfig();

  const mutation = useMutation({
    mutationKey: ['pauseAllContracts', contractId],
    mutationFn: () => pauseAll(apiHost, contractId),
  })

  return mutation;
}

export default usePauseAllContracts;
